//TextMobile.js
import { StatusBar } from 'expo-status-bar'
import React from 'react'
import { Text, View, Image, ScrollView, SafeAreaView } from 'react-native'
import * as Device from 'expo-device'
import LinkedInTag from 'react-linkedin-insight'

import styles from './Styles.js'

//import Head from './Head.js'
import Resume from './Resume.js'
import AboutMe from './AboutMe.js'
import Services from './Services.js'
import Contact from './Contact.js'
import Articles from './Articles.js'
import Copyright from './Copyright.js'

//const border = 1;

const TextMobile = ({navigation}) => {
  //const disabled = !user.allowsThirdPartyCookies();
  //LinkedInTag.init(partnerId, 'dc', disabled);
  //LinkedInTag.track(conversionId);
  return (
    <SafeAreaView style={styles.containerMobile}>
      <StatusBar style="auto" />
      <ScrollView style={styles.principalMobile}>
        <View style={styles.head}>
          <View style={{borderWidth: border, width: 200}}>
            <Text
              style={styles.titleTextBlack}
            >
              Marcio Adriano Seno
            </Text>
          </View>
          <View style={{borderWidth: border}}>
            <Text
              style={styles.linkBlack}
              onPress={() => {navigation.navigate('TextMobilePortuguês');}}
            >
              Por
            </Text>
          </View>
        </View>
        {Resume()}
        <Text> </Text>
        <Text> </Text>
        <View style={styles.logoViewMobile}>
          <Image style={styles.logoMobile} source={require('./img/LogoQuadradoCentralizado.png')} />
        </View>
        {AboutMe()}
        {Services()}
        {Contact()}
        <View style={styles.articlesMobile}>
          {Articles()}
        </View>
        <View style={styles.copyrightMobile}>
          {Copyright()}
        </View>
      </ScrollView>
    </SafeAreaView>
  )
};
export default TextMobile;
